import React, { useEffect, useState } from "react";
import Styles from "./InfoExchange.module.css";
import { Modal, Button } from "react-bootstrap";
import { Close, RemoveRedEye } from "@mui/icons-material";
import axios from "axios";
import { useSelector } from "react-redux";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import documentUploadService from "../Services/documentUpload.service";

const InfoExcangeModal = ({ open, handleClose, data }) => {
  const token = useSelector((state) => state?.sessionState?.token);
  const [currView, setCurrView] = useState("history");
  const [docId, setDocId] = useState("");
  const [docName, setDocName] = useState("");
  const [fileName, setFileName] = useState("");
  const [comment, setComment] = useState("");

  const [companyList, setCompanyList] = useState([]);
  useEffect(() => {
    handleFetchDocuments();
  }, []);
  const handleFileNameChange = (value) => {
    setFileName(value);
  };

  const handleCommentChange = (value) => {
    setComment(value);
  };

  const handleViewUpload = (type) => {
    setCurrView(type);
  };
  const handleViewHistory = (type) => {
    setCurrView(type);
    handleFetchDocuments();
  };
  const handlefileUpload = async (value, type) => {
    const selectedFile = value?.[0];
    setDocName(selectedFile?.name);
    const form = new FormData();
    form.append("file", selectedFile);
    form.append("type", type);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/document/upload`,
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.code === 200) {
        setDocId(response?.data?.data?.id);
      }
    } catch (error) {}
  };

  const handleSubmitForm = async () => {
    let payload = {
      fileName: fileName,
      docId: docId,
      uploadedBy: data?.bankingListing?.company?.companyName?.split(" ")?.[0],
      comments: comment,
      lisOne: data?.bankingListing?.name,
      lisTwo: data?.againstBankingListing?.name,
    };

    let res = await axios.post(
      `${process.env.REACT_APP_API_URL}/banking/submitBankingDocument`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (res?.data?.code === 200) {
      handleFetchDocuments();
      setCurrView("history");
    } else {
      alert("Something went wrong");
    }
  };

  const handleFetchDocuments = async () => {
    let res = await axios.get(
      `${process.env.REACT_APP_API_URL}/banking/getAllDocuments?lisOne=${data?.bankingListing?.name}&lisTwo=${data?.againstBankingListing?.name}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setCompanyList(res?.data?.data);
  };

  const handleViewPdf = async (id) => {
    let res = await documentUploadService.getDocumentById(id);
    if (res?.data?.code === 200) {
      let pdf = `data:application/pdf;base64,${res?.data?.data?.fileInBytes}`;
      const link = document.createElement("a");
      link.href = pdf;
      link.download = `${res?.data?.data?.fileName?.split(" ")?.[0]}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <>
      <Modal show={open} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={Styles.infoModalContainer}>
            <div className={Styles.infoHeader}>
              <div>Information Exchange</div>
              <Close
                onClick={handleClose}
                style={{ fontSize: "24px", cursor: "pointer" }}
              />
            </div>
            <div className={Styles.contHeadingElement}>
              <div className={Styles.listingIdsCont}>
                <span>{data?.bankingListing?.name}</span>
                <span>-</span>
                <span>{data?.againstBankingListing?.name}</span>
              </div>
              <div className={Styles.switchButtons}>
                <div
                  onClick={() => handleViewUpload("upload")}
                  className={
                    currView === "upload"
                      ? Styles.active_btn
                      : Styles.inactive_btn
                  }
                >
                  Upload
                </div>
                <div
                  onClick={() => handleViewHistory("history")}
                  className={
                    currView === "history"
                      ? Styles.active_btn
                      : Styles.inactive_btn
                  }
                >
                  View History
                </div>
              </div>
            </div>
            {currView === "upload" && (
              <div className={Styles.uploadMainCont}>
                <div className={Styles.uploadContL0Sec}>
                  <div className={Styles.eachInputCont}>
                    <div>Document Name</div>
                    <input
                      type="text"
                      name="name"
                      id="document-name-input"
                      value={fileName}
                      placeholder="Eg. Agreement"
                      onChange={(e) => handleFileNameChange(e.target.value)}
                    />
                  </div>
                  <div className={Styles.eachInputCont}>
                    <div>Upload Document</div>
                    <div className={Styles.inputFile}>
                      <input
                        type="file"
                        onChange={(e) =>
                          handlefileUpload(e.target.files, "INFO_EXCHANGE")
                        }
                        id="input-file"
                      />
                      <label className={Styles.inputLabel} htmlFor="input-file">
                        <AttachFileIcon style={{ height: "16px" }} />
                        <span>{docName || "Upload Document pdf File"}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className={Styles.eachInputCont}>
                  <div>Comments</div>
                  <input
                    type="text"
                    name="Comment"
                    id="Comment"
                    placeholder="Comment"
                    onChange={(e) => handleCommentChange(e.target.value)}
                  />
                </div>
                <div className={Styles.submitButton} onClick={handleSubmitForm}>
                  Submit
                </div>
              </div>
            )}
            {currView === "history" && (
              <div>
                <div className={Styles.tableHeadingCont}>
                  <div>Company</div>
                  <div>Date Time</div>
                  <div>File Name</div>
                  <div>View</div>
                </div>
                <div className={Styles.resuletContainerMain}>
                  {companyList?.map((ele) => (
                    <div className={Styles.tableListCont}>
                      <div>{ele?.uploadedBy}</div>
                      <div>{ele?.createdAt}</div>
                      <div>{ele?.fileName}</div>
                      <div onClick={() => handleViewPdf(ele?.docId)}>
                        <RemoveRedEye style={{ cursor: "pointer" }} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InfoExcangeModal;
